import api from '@/api';
import { PageResult } from '@/core/request/PageResult';
import { API_BASE_URL } from '..';
import {
  InvoiceCarrier,
  InvoiceCarrierListRequest,
  InvoiceCarrierRequest,
  InvoiceCarrierUpdateRequest,
} from './invoiceCarrier.types';

const BASE_URL = API_BASE_URL + '/carriers';

export async function listInvoiceCarrier(params?: InvoiceCarrierListRequest) {
  const result = (await api.get(BASE_URL, params)) as unknown;

  return result as PageResult<InvoiceCarrier>;
}

export async function createInvoiceCarrier(obj: InvoiceCarrierRequest) {
  const result = (await api.post(`${BASE_URL}`, obj, null)) as unknown;

  return result as InvoiceCarrier;
}

export async function updateInvoiceCarrier(obj: InvoiceCarrierUpdateRequest) {
  const result = (await api.put(`${BASE_URL}`, obj, null)) as unknown;

  return result as InvoiceCarrier;
}

export async function getInvoiceCarrier(id?: number) {
  const result = (await api.get(`${BASE_URL}/${id}`, null)) as unknown;

  return result as InvoiceCarrierRequest;
}

export async function removeInvoiceCarrier(id: number) {
  const result = (await api.remove(`${BASE_URL}/${id}`, {}, null)) as unknown;

  return result;
}
